// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(min-width: 1024px)";
var _3 = "inputError-3FfSc";
export { _1 as "__esModule", _2 as "desktop_only", _3 as "inputError" }
export default { "__esModule": _1, "desktop_only": _2, "inputError": _3 }
